const REPLIES = [
  ["agree", "I agree!"],
  ["disagree", "I don't agree."],
  ["more", "Tell me more"],
  ["why", "Why?"],
  ["example", "Can you give me an example?"],
  ["confused", "I don't understand"],
];

export const QuickReplies = ({ onPick, disabled }) => (
  <div data-testid="quick-replies" className="flex flex-nowrap sm:flex-wrap gap-2 mb-3 overflow-x-auto pb-1 -mx-1 px-1">
    {REPLIES.map(([id, text]) => (
      <button key={id} type="button" data-testid={`quick-reply-${id}`} disabled={disabled} onClick={() => onPick(text)} className="what-quick-reply shrink-0 whitespace-nowrap">
        {text}
      </button>
    ))}
  </div>
);
